import { render, staticRenderFns } from "./HandleFinancialData.vue?vue&type=template&id=732d6648&scoped=true"
import script from "./HandleFinancialData.vue?vue&type=script&lang=js"
export * from "./HandleFinancialData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "732d6648",
  null
  
)

export default component.exports